var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonContainer, Header, HeaderWrapper, Icon, IconWrapper, MainContainer, SubText, SubTextWrapper, Wrapper } from '../subcomponents';
var Eligible = function (_a) {
    var icon = _a.icon, header = _a.header, currentBalance = _a.currentBalance, subtext = _a.subtext, button = _a.button;
    var positiveAmount = currentBalance.slice(1);
    var newHeader = header.includes('Apply')
        ? header.replace('Apply ', "Apply $".concat(positiveAmount, " "))
        : header;
    return (_jsx(MainContainer, { children: _jsxs(Wrapper, { children: [_jsxs(HeaderWrapper, { children: [_jsx(IconWrapper, { children: _jsx(Icon, { children: icon }) }), _jsx(Header, { children: newHeader })] }), _jsx(SubTextWrapper, { children: _jsx(SubText, { children: subtext }) }), _jsx(ButtonContainer, __assign({ hasButton: Boolean(button) }, { children: button }))] }) }));
};
export default Eligible;
